import { ReactNode, useCallback } from 'react';

import { Button } from 'UIPackage/MainModule/components/Button';
import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';

import styles from './ConfirmModal.module.scss';

interface IConfirmModalProps {
  visible?: boolean;
  title: string;
  text?: string;
  children?: ReactNode;
  applyButtonText?: string;
  cancelButtonText?: string;
  onApply: () => void;
  onClose: () => void;
}

export const ConfirmModal = ({
  visible,
  title,
  text,
  children,
  applyButtonText = 'Да',
  cancelButtonText,
  onApply,
  onClose,
}: IConfirmModalProps) => {
  const handleApplyButtonClick = useCallback(() => {
    onApply();
    onClose();
  }, [onApply, onClose]);

  if (!visible) {
    return null;
  }

  return (
    <Modal visible={visible} onClose={onClose} modalBodyClassName={styles.Body}>
      <ModalHeader title={title} />
      <ModalBody size="content" border="bottom">
        <div className={styles.Text}>{text || children}</div>
      </ModalBody>
      <ModalActions>
        <Button
          text={applyButtonText}
          color="primary"
          size="medium"
          id="confirmButton"
          onClick={handleApplyButtonClick}
        />
        {cancelButtonText && <Button text={cancelButtonText} size="medium" onClick={onClose} />}
      </ModalActions>
    </Modal>
  );
};
